import type { Restaurant, User } from '../types';

/** Receipt self-signup store without HQ POS integration — web shows Receipt only, not POS menu/order tools. */
export function isPosDashboardEnabled(restaurant: Restaurant): boolean {
  const r = restaurant as Restaurant & {
    posDashboardEnabled?: boolean;
    receiptSelfSignup?: boolean;
    source?: string;
  };
  if (r.posDashboardEnabled === true) return true;
  if (r.posDashboardEnabled === false) return false;
  const receiptOnly =
    r.receiptSelfSignup === true || String(r.source || '') === 'receipt_self_signup';
  if (receiptOnly) return false;
  return true;
}

export function isReceiptSelfSignupRestaurant(restaurant: Restaurant): boolean {
  const r = restaurant as Restaurant & { receiptSelfSignup?: boolean; source?: string };
  return r.receiptSelfSignup === true || String(r.source || '') === 'receipt_self_signup';
}

/** Receipt signup owner before HQ enables POS portal — web hub only (PWA for capture). */
export function isReceiptOnlyWebOwner(user: Pick<User, 'role' | 'restaurantIds' | 'restaurantRoles'>): boolean {
  if (user.role === 'admin') return false;
  if (Object.keys(user.restaurantRoles || {}).length > 0) return false;
  return user.role === 'owner' && (user.restaurantIds?.length ?? 0) > 0;
}
